import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Icon, Menu, Dropdown, Tooltip } from 'antd';
import {
  Container,
  TemplateConatiner,
  EmptySettingsDetails,
  LoaderContainer,
  TemplateWrapper,
  TemplatePageOverview,
  TemplateShortMessageImage,
  DropdownDetails,
} from './styles';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import Loader from '../../components/Loader';
import CreateShortMsgTempModal from '../../components/CreateNewTemplate/CreateShortMsgTempModal';
import DeleteTemplateModal from '../../components/Modals/DeleteTemplateModal';
import LockStatusCheckModal from '../../components/Modals/LockStatusCheckModal';
import { getTemplateStatus } from '../../utils/services/templatesAPI';

// app store context API
import { dayConversion, monthConversion } from '../../utils/javascript';
import { AppStoreContext } from '../../context/appStoreContext';
import { SHORT_MESSAGE_TEMPLATES_LIST } from './translationValues';
import { useTranslation } from 'react-i18next';
import { checkUserAccessRoles } from '../../utils/helper';

const NAMESPACES = ['SHORT_MESSAGE_TEMPLATES_LIST'];
const ShortMessageTemplateSection = props => {
  const { tempCategories, activeContent, languageList } = props;
  const { t } = useTranslation(NAMESPACES); 
  const {
    loginVisible,
    userDetails,
    templatesList,
    totalTemplates,
    fetchingCategories,
    checkUserAccess,
  } = useContext(AppStoreContext);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [lockedBy, setLockedBy] = useState({});
  const [cloneTemplate, setCloneTemplate] = useState(undefined);
  const history = useHistory();
  const accessUpdateTemplate =   checkUserAccessRoles(userDetails, ['DESIGNER', 'PUBLISHER']);

  useEffect(() => {
    if (
      loginVisible === false &&
      Boolean(selectedTemplate) &&
      Boolean(selectedTemplate.id) &&
      !Boolean(selectedAction)
    ) {
      history.push(`/design/${selectedTemplate.id}`);
    }
  }, [loginVisible, selectedTemplate, selectedAction, history]);

  const enableModalVisibility = async (actionType, template) => {
    const checkStatus = ['delete-template'].some(data => data === actionType);
    if (checkStatus) {
      actionType = (await checkTemplateStatus(template)) || actionType;
    }
    setUpdateModalVisibility(true);
    setSelectedAction(actionType);
    setSelectedTemplate(template);
  };

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setSelectedAction(null);
    setSelectedTemplate(null);
  };

  const redirectToTemplate = template => {
    setCloneTemplate(undefined);
    if (template.id) {
      history.push(`/shortMessageDesign/${template.id}`);
    }
  };

  const onSuccessDeletion = async () => {
    setUpdateModalVisibility(false);
    props.deteteTemplate(true);
  };

  const checkTemplateStatus = async template => {
    const templateStatus = await getTemplateStatus(template.id, 'printTemplate');
    if (templateStatus?.data) {
      const { locked, lockedBy } = templateStatus.data;
      if (userDetails && locked && lockedBy) {
        const locked = userDetails.id !== lockedBy.userId;
        if (locked) {
          setLockedBy(lockedBy);
          setSelectedAction('template-locked');
          setUpdateModalVisibility(true);
          return 'template-locked';
        }
      }
    }
  };
  const truncate = input => (input.length > 150 ? `${input.substring(0, 150)}...` : input);

  const getTemplateContent = obj => {
    let templateContent = '';

    if (activeContent === 'sms') {
      if (obj.sms)
        obj.sms.map(value => {
          templateContent = templateContent + value.textValue;
        });
      return truncate(templateContent);
    } else if (activeContent === 'whatsapp') {
      if (obj.whatsapp)
        obj.whatsapp.map(value => {
          templateContent = templateContent + value.textValue;
        });
      return truncate(templateContent);
    } else {
      if (obj.call)
        obj.call.map(value => {
          templateContent = templateContent + value.textValue;
        });
      return truncate(templateContent);
    }
  };
  const renderBody = (categoriesTemp, templatesList) => {
    return (
      <React.Fragment>
        {templatesList.length > 0 && (
          <>
            <TemplateWrapper>
              {templatesList.map(templateObj => {
                let categoryByTemplate = {
                  id: templateObj.id,
                  name: templateObj.name,
                  categoryId: templateObj.categoryId,
                  type: templateObj.type,
                };
                return (
                  <div key={templateObj.id}>
                    <div className="test">
                      <TemplatePageOverview
                        key={templateObj.id}
                        title={templateObj.name}
                        onClick={() => accessUpdateTemplate && redirectToTemplate(templateObj)}
                      >
                        <TemplateShortMessageImage activeContent={activeContent}>
                          {templatesList.length > 0 && <p>{getTemplateContent(templateObj)}</p>}
                          <div className="image-wrapper">
                            {(templateObj.updatedOn || templateObj.createdOn) && (
                              <div className="template_date">
                                <p>
                                  {templateObj.updatedOn
                                    ? dayConversion(templateObj.updatedOn)
                                    : dayConversion(templateObj.createdOn)}
                                </p>
                                <p className="month">
                                  {templateObj.updatedOn
                                    ? monthConversion(templateObj.updatedOn)
                                    : monthConversion(templateObj.createdOn)}
                                </p>
                              </div>
                            )}
                          </div>
                          <DropdownDetails
                            id={`${templateObj.id}-template`}
                            className="dropdown-menu"
                            onClick={e => e.stopPropagation()}
                          >
                            <Dropdown
                              overlay={
                                <Menu>
                                  <Menu.Item
                                    key="0"
                                    onClick={() => redirectToTemplate(templateObj)}
                                  >
                                    {t(
                                      SHORT_MESSAGE_TEMPLATES_LIST.EDIT_TEMPLATE_DROPDOWN_OPTION
                                        .key,
                                      SHORT_MESSAGE_TEMPLATES_LIST.EDIT_TEMPLATE_DROPDOWN_OPTION
                                        .value,
                                    )}
                                  </Menu.Item>
                                  <Menu.Item
                                    key="1"
                                    onClick={() =>
                                      enableModalVisibility('delete-template', categoryByTemplate)
                                    }
                                  >
                                    {t(
                                      SHORT_MESSAGE_TEMPLATES_LIST.DELETE_TEMPLATE_DROPDOWN_OPTION
                                        .key,
                                      SHORT_MESSAGE_TEMPLATES_LIST.DELETE_TEMPLATE_DROPDOWN_OPTION
                                        .value,
                                    )}
                                  </Menu.Item>
                                </Menu>
                              }
                              trigger={['click']}
                              getPopupContainer={() =>
                                document.getElementById(`${templateObj.id}-template`)
                              }
                            >
                              <Icon type="more" />
                            </Dropdown>
                          </DropdownDetails>
                        </TemplateShortMessageImage>
                        <div className="template_name">
                          <div
                            className="name"
                            onClick={() => accessUpdateTemplate && redirectToTemplate(templateObj)}
                          >
                            {templateObj.name}{' '}
                          </div>
                          <div className="categoryName">
                            <div className="box2"></div>
                            {categoriesTemp.length > 0 &&
                              categoriesTemp.map(category => (
                                <div key={category.categoryId}>
                                  {templateObj.categoryId === category.categoryId &&
                                    category.categoryName}
                                </div>
                              ))}
                              {templateObj?.language && (
                                <Tooltip title={languageList?.find(ln => ln.code === templateObj?.language)?.name} trigger="hover">
                                  <div className="language-tag">{templateObj?.language}</div>
                                </Tooltip>
                              )}
                          </div>
                        </div>
                      </TemplatePageOverview>
                    </div>
                  </div>
                );
              })}
            </TemplateWrapper>
          </>
        )}
      </React.Fragment>
    );
  };
  return (
    <Container>
      {fetchingCategories ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <TemplateConatiner>
          {totalTemplates === 0 ? '' : renderBody(tempCategories, templatesList)}
          {templatesList && templatesList.length !== 0 && (
            <>
              {templatesList.length !== totalTemplates ? (
                <div className="addMore">
                  <Icon type="loading" />
                  {t(
                    SHORT_MESSAGE_TEMPLATES_LIST.LOADING_MORE.key,
                    SHORT_MESSAGE_TEMPLATES_LIST.LOADING_MORE.value,
                  )}
                </div>
              ) : (
                <div className="allData">
                  {t(
                    SHORT_MESSAGE_TEMPLATES_LIST.GOT_ALL_TEMPLATES_LIST.key,
                    SHORT_MESSAGE_TEMPLATES_LIST.GOT_ALL_TEMPLATES_LIST.value,
                  )}
                </div>
              )}
            </>
          )}

          {!fetchingCategories &&
            updateModalVisibility &&
            !loginVisible &&
            selectedAction &&
            (selectedAction === 'create-template' ? (
              <CreateShortMsgTempModal
                visible={updateModalVisibility}
                onCancel={disableModalVisibility}
                onSucess={redirectToTemplate}
                categoryType="template"
              />
            ) : (
              ''
            ))}
          {!fetchingCategories &&
            updateModalVisibility &&
            !loginVisible &&
            selectedAction &&
            (selectedAction === 'delete-template' ? (
              <DeleteTemplateModal
                visible={updateModalVisibility}
                onCancel={disableModalVisibility}
                targetTemplate={selectedTemplate}
                categoryType="template"
                onSucess={onSuccessDeletion}
                isShortMessageTemplate={true}
              />
            ) : (
              ''
            ))}
          {!fetchingCategories &&
            updateModalVisibility &&
            !loginVisible &&
            selectedAction &&
            selectedAction === 'template-locked' && (
              <LockStatusCheckModal
                visible={updateModalVisibility}
                lockedBy={lockedBy}
                onCancel={disableModalVisibility}
              />
            )}
          {cloneTemplate && (
            <CreateShortMsgTempModal
              visible={true}
              onCancel={() => setCloneTemplate(false)}
              onSucess={redirectToTemplate}
              categoryType="template"
              type="cloneTemplate"
              template={cloneTemplate}
            />
          )}
        </TemplateConatiner>
      )}
      {!fetchingCategories && templatesList.length === 0 && (
        <EmptySettingsDetails>
          <div className="empty-illustration">
            <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
          </div>
          <div className="empty-txt" style={{ color: 'black' }}>
            <span>
              {t(
                SHORT_MESSAGE_TEMPLATES_LIST.EMPTY_TEMPLATES_LIST.key,
                SHORT_MESSAGE_TEMPLATES_LIST.EMPTY_TEMPLATES_LIST.value,
              )}
            </span>
            <span
              className="empty-links"
              onClick={() => enableModalVisibility('create-template', null)}
            >
              {t(
                SHORT_MESSAGE_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_ACTION.key,
                SHORT_MESSAGE_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_ACTION.value,
              )}
            </span>
            <span>
              {t(
                SHORT_MESSAGE_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_INFO.key,
                SHORT_MESSAGE_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_INFO.value,
              )}
            </span>
          </div>
        </EmptySettingsDetails>
      )}
    </Container>
  );
};

export default ShortMessageTemplateSection;
